module.exports = __webpack_public_path__ + "img/IMG_6413 1.442afa35.webp";